import {
  AboutmeContainer,
  AboutmeTitle,
  AboutmeDescription,
  AboutmeImage,
  AboutmeContent,
  AboutDescContainer,
} from "../../styles/aboutme/indexAboutme";
import Fade from "react-reveal/Fade";
import { Box } from "@mui/material";

export default function Aboutme() {
  // const theme = useTheme();
  // const matches = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <AboutmeContainer id="aboutme">
      <AboutmeContent>
        <AboutmeTitle variant="h6">About me</AboutmeTitle>
        <Fade cascade>
          <AboutDescContainer>
            <Box justifyContent="center" mr="30px">
              <AboutmeImage src="/images/banner/DSCN0148.png" />
            </Box>
            <Box
              display="flex"
              textAlign="justifyContent"
              maxWidth="600px"
              height="200=px"
            >
              <AboutmeDescription>
                <section>
                  I’m a Data Analyst who loves turning messy, multi source data into clear insights that actually help organizations work smarter. I work hands on with Microsoft Power BI, Advanced Excel, SQL, and Python to build automated data pipelines, intuitive dashboards, and analytics solutions that support confident, data driven decisions.
                </section>
                <br></br>
                <section>
                  My experience covers data modelling, visualization, KPI design, forecasting, time intelligence, and supervised machine learning, with some extra background in JavaScript and C#, and frameworks like ReactJs. A core part of my work is data storytelling, where I translate technical findings into accessible, compelling stories that drive clarity and impact narratives for both technical and non technical audiences.
                </section>
                <br></br>
                <section>
                  My work is grounded in a strong foundation in Mathematics and Statistics, strengthened by experience in teaching and mentoring, which really shaped how I communicate complex ideas. I’m currently working toward my master’s degree in Data Analytics and staying committed to continuous learning and keeping up with modern analytics practices.
                </section>

                
              </AboutmeDescription>
            </Box>
          </AboutDescContainer>
        </Fade>
      </AboutmeContent>
    </AboutmeContainer>
  );
}
